import { Button } from "@mui/material";
import styled from "@mui/material/styles/styled";

import { Row } from "@rui/Stack";

export const RollupFilterContainer = styled(Row)(({ theme }) => ({
  width: "100%",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: theme.palette.shades.ghost[300],
  padding: theme.spacing(1.5, 1),
  position: "fixed",
  bottom: 0,

  [theme.breakpoints.down("mobile")]: {
    zIndex: 10,
    borderTop: "1px solid",
    borderColor: theme.palette.transparent.black[8],
  },
  [theme.breakpoints.up("mobile")]: {
    justifyContent: "space-between",
    padding: theme.spacing(2, 3),
    position: "relative",
  },
}));

export const FiltersContainer = styled(Row)(({ theme }) => ({
  gap: theme.spacing(1),
  flex: 1,
  flexShrink: 1,
  [theme.breakpoints.up("mobile")]: {
    gap: theme.spacing(2),
  },
  [theme.breakpoints.down("lg")]: {
    maxWidth: "100%",
  },
}));

export const FilterDropdownButton = styled(Button)(({ theme }) => ({
  backgroundColor: "#FFF",
  minWidth: 0,
  width: "100%",
  maxWidth: "100%",
  border: "1px solid",
  borderColor: theme.palette.shades.neutral[100],
  borderRadius: theme.corners.base,
  height: "32px",
  fontWeight: 400,
  justifyContent: "flex-start",

  "& .filter-dropdown__label": {
    flex: 1,
    textAlign: "left",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    color: theme.palette.shades.neutral[600],
  },

  "& .MuiButton-startIcon": {
    color: theme.palette.shades.primary[500],
    margin: 0,
  },

  "& .MuiButton-endIcon": {
    justifySelf: "flex-end",
    color: theme.palette.shades.neutral[600],
    margin: 0,
    marginLeft: theme.spacing(0.5),
  },

  "&.Mui-disabled": {
    backgroundColor: theme.palette.shades.neutral[50],
    "& .MuiButton-startIcon": {
      color: theme.palette.shades.primary[300],
    },
  },

  [theme.breakpoints.down("mobile")]: {
    height: "32px",
    flexShrink: 1,
    flexBasis: "50%",
    "& .MuiButton-startIcon": {
      display: "none",
    },
  },

  [theme.breakpoints.up("mobile")]: {
    height: "38px",
    width: "220px",
    flexShrink: 1,
  },
}));
